import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { IconMenu2, IconX } from '@tabler/icons-react';
import {
	NavDropdown,
	NavDropdownItem,
	NavDropdownLinkItem,
	NavItem,
} from 'components/nav';
import { AuthNavBar } from 'components/auth';

function Navigation() {
	const { pathname, hash } = useLocation();
	const [isVisible, setVisible] = useState(false);

	const handleToggle = (e) => {
		e.preventDefault();
		setVisible((visible) => !visible);
	};

	useEffect(() => {
		setVisible(false);
	}, [pathname, hash]);

	return (
		<nav
			className="fixed top-0 left-0 right-0 z-50 bg-[--color-bg-primary] border-b border-[--color-border-subtle]"
			style={{ height: '52px' }}
		>
			<div className="max-w-7xl mx-auto px-6 h-full flex items-center">
				<NavLink
					to="/"
					className="flex items-center gap-2 font-montserrat font-semibold text-[15px] tracking-tight text-[--color-text-primary] mr-6"
				>
					<span className="w-2 h-2 rounded-full bg-cr-green shrink-0" />
					CR Flow
				</NavLink>

				<ul className="hidden md:flex items-center gap-1 ml-auto">
					<NavItem name="Dashboard" to="/" />
					<NavItem name="Flow" to="/flows" />
					<NavDropdown name="Enheter">
						<NavDropdownItem name="Hue" to="/device/hue" />
						<NavDropdownItem name="Zigbee" to="/device/zigbee" />
						<NavDropdownLinkItem
							name="Zigbee UI"
							to="https://zigbee.kube.crundberg.se"
						/>
						<NavDropdownItem
							name="Google Calendar"
							to="/device/googlecalendar"
						/>
					</NavDropdown>
					<NavDropdown name="Debug">
						<NavDropdownItem name="Enheter" to="/device/debug" />
						<NavDropdownItem name="Triggers" to="/trigger/debug" />
					</NavDropdown>
					<NavItem name="Inställningar" to="/settings" />
					<AuthNavBar />
				</ul>

				<button
					type="button"
					className="md:hidden ml-auto text-[--color-text-secondary] hover:text-[--color-text-primary] transition-colors p-1"
					aria-label="Toggle navigation"
					onClick={handleToggle}
				>
					{isVisible ? <IconX size={20} /> : <IconMenu2 size={20} />}
				</button>
			</div>

			{isVisible && (
				<div className="md:hidden bg-[--color-bg-primary] border-t border-[--color-border-subtle] px-6 py-3">
					<ul className="space-y-1">
						<NavItem name="Dashboard" to="/" />
						<NavItem name="Flow" to="/flows" />
						<NavDropdown name="Enheter">
							<NavDropdownItem name="Hue" to="/device/hue" />
							<NavDropdownItem name="Zigbee" to="/device/zigbee" />
							<NavDropdownLinkItem
								name="Zigbee UI"
								to="https://zigbee.kube.crundberg.se"
							/>
							<NavDropdownItem
								name="Google Calendar"
								to="/device/googlecalendar"
							/>
						</NavDropdown>
						<NavDropdown name="Debug">
							<NavDropdownItem name="Enheter" to="/device/debug" />
							<NavDropdownItem name="Triggers" to="/trigger/debug" />
						</NavDropdown>
						<NavItem name="Inställningar" to="/settings" />
						<AuthNavBar />
					</ul>
				</div>
			)}
		</nav>
	);
}

export default Navigation;
